import apiHandler from "../core/apiHandler";

const documentTypeApi = apiHandler('document-types');
export default documentTypeApi;
